<template>
  <div class="container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12">
        <h1 class="ota-title mb-3 text-center md:mb-10" v-text="$t('Imprint.Content.Title')" />
      </div>
      <div class="lg:flex pt-12">
        <p class="ota-subtitle pb-12 pr-10 lg:pt-4" v-html="$t('Imprint.General.Subjects')" />
        <div class="mb-10 flex-1 flex justify-end">
          <div class="right-flex w-full">
            <ProductAccordion
              v-for="(contentBlock, index) in content"
              :key="`${contentBlock.Title}-${index}`"
              class="mt-5 border-b"
            >
              <template v-slot:trigger>
                {{ contentBlock.Title }}
              </template>
              <template v-slot:content>
                <div class="ota-small-light pb-5 md:pb-10" v-html="contentBlock.Content" />
              </template>
            </ProductAccordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductAccordion from '@/components/Webshop/ProductAccordion'

export default {
  name: 'Imprint',
  layout: 'homepage',
  components: { ProductAccordion },
  computed: {
    content () {
      return [...Array(this.$t('Imprint.Content.Topics').length)].map((_, index) => ({
        Title: this.$t(`Imprint.Content.Topics[${index}].Title`),
        Content: this.$t(`Imprint.Content.Topics[${index}].Content`, {
          adjustDataLink: `<a href="${this.$t('FooterLinks.FaqAdjustData')}">${this.$t('Imprint.General.Here')}</a>`
        })
      }))
    }
  },
  head () {
    return {
      title: this.$t('Imprint.PageTitle'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('Imprint.Description')
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-accordion {
  >>> b {
    @apply font-extrabold;
  }

  >>> .ota-p18 {
    font-size: 1.5rem;
  }
}

.right-flex {
  max-width: 75rem;
}
</style>
